/* Taxxal Produktseite: Galerie, Set-Auswahl, feste Kaufleiste auf dem Handy */
(function () {
  var box = document.querySelector('.tx-buy');
  if (!box) return;
  var track = box.querySelector('#tx-gal-track');
  var thumbs = box.querySelectorAll('.tx-gal__thumbs button');
  var count = box.querySelector('#tx-gal-n');
  var prev = box.querySelector('.tx-gal__nav--prev');
  var next = box.querySelector('.tx-gal__nav--next');
  var current = 0;
  var slides = track ? track.children.length : 0;
  var go = function (i, smooth) {
    if (!track) return;
    i = Math.max(0, Math.min(slides - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
  };
  var mark = function (i) {
    current = i;
    thumbs.forEach(function (t, n) {
      if (n === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
    });
    if (count) count.textContent = i + 1;
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides - 1;
  };
  if (track) {
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== current) mark(i);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.i, 10)); });
    });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    mark(0);
  }
  var price = box.querySelector('#tx-buy-price');
  var sb = box.querySelector('#tx-sbuy');
  var sbPrice = box.querySelector('#tx-sbuy-price');
  var sbName = box.querySelector('#tx-sbuy-name');
  var buy = box.querySelector('.tx-btn--buy');
  var form = box.querySelector('form');
  box.querySelectorAll('input[name="id"]').forEach(function (r) {
    r.addEventListener('change', function () {
      if (price) price.textContent = r.dataset.price;
      if (sbPrice) sbPrice.textContent = r.dataset.price;
      if (sbName) sbName.textContent = r.dataset.name;
    });
  });
  if (sb && buy && form) {
    sb.querySelector('button').addEventListener('click', function () {
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });
    var check = function () { sb.classList.toggle('is-on', buy.getBoundingClientRect().bottom < 0); };
    document.addEventListener('scroll', check, { capture: true, passive: true });
    check();
  }
})();
